export const getInactiveDays = (): boolean => false;
